import "./App.css";
import React, { useState } from "react";
import ErrorBoundary from "./ui-components/ErrorBoundary";
import CountrySelection from "./CountrySelection";
import Router from "./Router";
import CountryContext from "./CountryContext";
import CountryConfigContext from "./CountryConfigContext";
import useActiveCountry from "./hooks/useActiveCountry";
import useCountryAxiosInstance from "./hooks/useCountryAxiosInstance";
import { useLocation } from "react-router-dom";

function usePageViews(countryApiRequest) {
  const location = useLocation();

  React.useEffect(() => {
    if (!countryApiRequest) return;

    // Define Log Variable
    let logging = {};

    const loggingInfo = window.localStorage.logged_user
      ? JSON.parse(window.localStorage.logged_user)
      : null;

    // Log information on page change
    // PAGE
    logging["page"] = [null, ...location.pathname.split("/").splice(2)].join(
      "/"
    );
    // DEVICE INFO
    let device = window.navigator.userAgentData;
    let browser = device?.brands?.length > 0 ? device.brands[2] : null;
    logging["browser"] = browser?.brand;
    logging["browser_version"] = parseFloat(browser?.version);
    logging["mobile"] = device?.mobile;
    logging["platform"] = device?.platform;
    logging["user"] = loggingInfo?.email;

    // POST
    countryApiRequest.post("/audit/navigation", logging, {
      publicRequest: false,
      audit: true,
    });
  }, [location, countryApiRequest]);
}

function App() {
  const [country, setCountry] = useActiveCountry();
  const [config, setConfig] = useState(null);
  const countryApiRequest = useCountryAxiosInstance(country?.code, false);

  usePageViews(countryApiRequest);

  return (
    <ErrorBoundary activeCountry={config !== null} {...{ countryApiRequest }}>
      <CountryContext.Provider value={{ country, setCountry }}>
        <CountryConfigContext.Provider value={{ config, setConfig }}>
          <CountrySelection>
            <Router />
          </CountrySelection>
        </CountryConfigContext.Provider>
      </CountryContext.Provider>
    </ErrorBoundary>
  );
}

export default App;
